export { registerArcGraphic } from './register-arc';
export { registerArc3dGraphic } from './register-arc3d';
export { registerAreaGraphic } from './register-area';
export { registerCircleGraphic } from './register-circle';
export { registerGlyphGraphic } from './register-glyph';
export { registerGroupGraphic } from './register-group';
export { registerImageGraphic } from './register-image';
export { registerLineGraphic } from './register-line';
export { registerPathGraphic } from './register-path';
export { registerPolygonGraphic } from './register-polygon';
export { registerPyramid3dGraphic } from './register-pyramid3d';
export { registerRectGraphic } from './register-rect';
export { registerRect3dGraphic } from './register-rect3d';
export { registerRichtextGraphic } from './register-richtext';
export { registerShadowRootGraphic } from './register-shadowRoot';
export { registerStarGraphic } from './register-star';
export { registerSymbolGraphic } from './register-symbol';
export { registerTextGraphic } from './register-text';
export { registerWrapTextGraphic } from './register-wraptext';
